import React from 'react';
import { useLocation } from 'react-router-dom';

const useSearchParams = () => {
  const location = useLocation();

  const { search } = location;

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export default useSearchParams;
